var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportCsv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    fillRule: "nonzero",
    d: "M8.421 0v3.994c0 .16.115.295.269.326l.068.006H12.8v10.65c0 .185-.115.34-.269.376l-.068.008H.337c-.163 0-.299-.132-.33-.307L0 14.976V.333C0 .173.115.038.269.007L.337 0H8.42zm.343 12.145H3.527c-.18 0-.327.147-.327.328 0 .18.147.327.327.327h5.237c.18 0 .327-.147.327-.327 0-.181-.147-.328-.327-.328zM6.145 5.6c-.158 0-.29.112-.32.261l-.007.066v4.228L3.946 8.283l-.06-.047c-.126-.078-.294-.063-.403.047-.126.126-.126.33 0 .457l.001.001.002.002 2.439 2.38.036.03.04.022.042.014.036.004.066.007.033-.002c.044.003.088-.006.128-.027l.055-.04 2.473-2.39c.13-.129.13-.333.004-.458-.11-.11-.277-.125-.403-.047l-.06.047-1.903 1.902V5.927c0-.18-.146-.327-.327-.327z",
    transform: "translate(-199 -208) translate(199 208)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    fillRule: "nonzero",
    d: "M9.216 0.512L9.216 3.584 12.288 3.584z",
    transform: "translate(-199 -208) translate(199 208)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportCsv);
export default __webpack_public_path__ + "static/media/export_csv.6ba53290b774d3710acc87657b9caa56.svg";
export { ForwardRef as ReactComponent };